export default {
  en: {
    title: 'Sub-entities',
    pageTitle: 'Sub-entities - {0}',
    pageHeader: 'Sub-entities',
    entityName: 'Sub-entity',
    dataTableColumns: {
      name: 'Sub-entity name',
      companyNumber: 'Company number',
      website: 'Website',
      country: 'Country',
      sector: 'Sector',
      dateAdded: 'Date added',
      dateInvited: 'Date invited',
      inviteSender: 'Invite sender',
      numSuppliers: 'Suppliers',
      numClients: 'Clients',
      numSuppliersApproved: 'Suppliers approved',
      numSuppliersRejected: 'Suppliers rejected',
      avgSuppliersCompliance: 'Suppliers average compliance',
      labels: 'Labels',
    },
    dataTableFilters: {
      name: 'Sub-entity name',
      companyNumber: 'Company number',
      website: 'Website',
      country: 'Country',
      sector: 'Sector',
      dateAdded: 'Date added',
      dateInvited: 'Date invited',
      inviteSender: 'Invite sender',
      numSuppliers: 'Number of suppliers',
      numClients: 'Number of clients',
      numSuppliersApproved: 'Number of suppliers approved',
      numSuppliersRejected: 'Number of suppliers rejected',
      avgSuppliersCompliance: 'Average suppliers compliance',
      labels: 'Labels',
    },
    placeholders: {
      emptyTitle: 'Sub-entities',
      emptyDescription: 'No sub-entities could be found',
      errorTitle: 'Sub-entities',
      errorDescription: 'Failed fetching sub-entities',
    },
    misc: {
      deletedUser: 'deletedUser',
      filterResultsSubEntities: '{count} sub-entities | {count} sub-entity | {count} sub-entities',
      filterResultsOutOf: '{0} out of {1}',
      export: 'Export',
      exportError: 'There was an error attempting to export the current view',
    },
  },
};
